import React from 'react';
import {KeolisSpinner} from '../containers/common/commonExport';

//whether the action took place or not
const ActionInProgress = (props) => (
    <div className={"printContainer " + (props.showActionInProgress === true ? '' : 'hidden')}>
        <div className='printOverlay'></div>
        <div className='printProgress'>
            <span>In progress </span>
            
            <KeolisSpinner />
        </div>
    </div>
);

export default ActionInProgress;